export const WithdrawStatus = {
  Pending: "Pending",
  Awaited: "Awaited",
  Verified: "Verified",
};